import PersonalDetailModel from "../panels/personalDetailModel";
import PetDetailModel from "../panels/petDetailModel";

export default class PetOwnerInquiryModel {
    serviceId: number = 0;
    servicePathId: number = 0;
    petDetails: PetDetailModel | null = null;
    personalDetails: PersonalDetailModel | null = null;

    constructor() { }
}
